import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Cast from './cast-model'
import { CreateCastAsync, DeleteCastAsync, LoadCastsAsync } from './cast-thunk'
const initialState: castSliceState = {
  cast: [],
  selected_cast: '',
  is_loading_cast: false,
  is_creating_cast: false,
  is_deleting_cast: false,
}
export interface castSliceState {
  cast: Cast[]
  selected_cast?: string
  is_loading_cast: boolean
  is_creating_cast: boolean
  is_deleting_cast: boolean
}
export const castSlice = createSlice({
  name: 'cast',
  initialState,
  reducers: {
    setSelectedcast: (state, action) => {
      state.selected_cast = action.payload
    },
    clearStatecast: (state) => {
      state.cast = []
      state.is_loading_cast = false
      state.is_creating_cast = false
      state.is_deleting_cast = false
    },
    mergecast: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_cast = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.cast = merge(state.cast, payload) as any
        }
      }
    },

    add_cast: (state, action) => {
      if (action.payload) {
        state.cast = [...state.cast, action.payload]
      }
    },
    set_cast: (state, action) => {
      let { key, value, id } = action.payload
      state.cast = state.cast.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCastsAsync.pending, (state) => {
      state.is_loading_cast = true
    })
    builder.addCase(LoadCastsAsync.fulfilled, (state, action) => {
      state.is_loading_cast = false
      if (action.payload) {
        state.cast = action.payload
      }
    })
    builder.addCase(LoadCastsAsync.rejected, (state) => {
      state.is_loading_cast = false
    })
    builder.addCase(CreateCastAsync.pending, (state) => {
      state.is_creating_cast = true
    })
    builder.addCase(CreateCastAsync.fulfilled, (state) => {
      state.is_creating_cast = false
    })
    builder.addCase(CreateCastAsync.rejected, (state) => {
      state.is_creating_cast = false
    })
    builder.addCase(DeleteCastAsync.pending, (state) => {
      state.is_deleting_cast = true
    })
    builder.addCase(DeleteCastAsync.fulfilled, (state, action) => {
      state.is_deleting_cast = false
      if (state.cast) {
        state.cast = state.cast.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteCastAsync.rejected, (state) => {
      state.is_deleting_cast = false
    })
  },
})

export const {
  clearStatecast,
  setSelectedcast,
  set_cast,
  mergecast,
  add_cast,
} = castSlice.actions

export const get_cast =
  (id?: string) =>
  (state: {
    cast: {
      cast: Cast[]
    }
  }): Cast | null => {
    let temp = state?.cast?.cast?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.cast?.cast[0] || null
  }
export const get_selected_cast = (state: {
  cast: castSliceState
}): Cast | null => {
  let id = state?.cast?.selected_cast
  let temp = state?.cast?.cast?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_cast = (state: {
  cast: {
    cast: Cast[]
  }
}): Cast[] => {
  let temp = state?.cast?.cast
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_cast_busy = (state: { cast: castSliceState }) => {
  return (
    state?.cast.is_deleting_cast ||
    state?.cast.is_loading_cast ||
    state?.cast.is_creating_cast
  )
}
export const is_deleting_cast_busy = (state: { cast: castSliceState }) => {
  return state?.cast.is_deleting_cast
}
export const is_loading_cast_busy = (state: { cast: castSliceState }) => {
  return state?.cast.is_loading_cast
}
export const is_creating_cast_busy = (state: { cast: castSliceState }) => {
  return state?.cast.is_creating_cast
}

export default castSlice.reducer
